import React, { useCallback, useState, useRef, useEffect } from "react";

import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";

import { useDispatch, useSelector } from "react-redux";

import { fetchTicketsByEstateIdThunk } from "../modules/ticket/ticketList/ticketListSlice";
import { fetchPostingsByEstateIdThunk } from "../modules/postings/postingList/postingListActions";
import { currentEstateSelectors } from "../modules/estate/currentEstate/currentEstateSlice";

// Functional refactor of the previous class-based component. Keeps behavior identical
// while removing unused state (auth) and leveraging hooks for simplicity & clarity.
const RefreshButton = () => {
  const dispatch = useDispatch();
  const estateId = useSelector(currentEstateSelectors.selectCurrentEstate).id;

  // spin control
  const [spinning, setSpinning] = useState(false);
  const [disableTransition, setDisableTransition] = useState(false);
  const timerRef = useRef(null);
  const SPIN_MS = 400;

  const handleRefresh = useCallback(() => {
    dispatch(fetchTicketsByEstateIdThunk(estateId));
    dispatch(fetchPostingsByEstateIdThunk(estateId));
  }, [dispatch, estateId]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const onClick = useCallback(() => {
    if (spinning) return; // ignore while animating

    setDisableTransition(false);
    setSpinning(true);

    timerRef.current = setTimeout(() => {
      // reset without transition so next click will animate again
      setDisableTransition(true);
      setSpinning(false);
    }, SPIN_MS);

    handleRefresh();
  }, [spinning, handleRefresh]);

  return (
    <div>
      <IconButton onClick={onClick} color="inherit" size="large">
        <RefreshIcon
          style={{
            transform: spinning ? "rotate(360deg)" : "rotate(0deg)",
            transition: disableTransition
              ? "none"
              : `transform ${SPIN_MS}ms linear`,
          }}
        />
      </IconButton>
    </div>
  );
};

export default React.memo(RefreshButton);
